











import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { debounce, dom } from 'quasar'

@Component
export default class ScaleView extends Vue {
  zoom = 1

  container = {
    fontSize: '24px',
    height: 'auto'
  }

  scale = {
    width: '100%',
    height: 'auto',
    transform: '',
    transformOrigin: 'top left'
  }

  @Prop()
  readonly referenceWidth!: number

  @Ref()
  readonly viewport!: HTMLElement

  created () {
    this.resizeSetHeight = debounce(this.resizeSetHeight, 100)
  }

  resize (size: { width: number }) {
    this.zoom = size.width / this.referenceWidth
    this.scale.width = size.width * (1/this.zoom) + 'px'
    this.scale.transform = `scale(${this.zoom})`
    this.$emit('scale', this.zoom)
    this.resizeSetHeight()
  }

  resizeSetHeight () {
    if (this.viewport) {
      const { height } = dom
      const viewheight = height(this.viewport)
      if (viewheight) {
        this.container.height = viewheight + 'px'
      }
    }
  }
}
